import { useModal } from "contexts/modalContext/modalContext.js";
import UploadContactsPictureModal from "../UploadContactsPictureModal.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { Dispatch, SetStateAction } from "react";

interface ContactEditImageComponentI {
  setContactList: Dispatch<SetStateAction<any>>;
  details: Record<string, any>;
  getTextByKey: (key: string) => string;
}

export const ContactEditImageComponent = ({
  setContactList,
  details,
  getTextByKey,
}: ContactEditImageComponentI) => {
  const { setModal, closeModal } = useModal();

  const contactEmail =
    details && details.contact_list_email ? details.contact_list_email : null;
  const isOwnerPicture =
    details && details.contact_list_is_owner_image
      ? details.contact_list_is_owner_image
      : false;

  const deleteContactProfilePicture = async () => {
    const response = await apiRequest(
      "ContactsLists",
      `DeleteContactProfilePicture?contactEmail=${contactEmail}`,
      null,
      "POST"
    );
    // set contactList picture to null if success
    if (response.status === "success") {
      setContactList((prev) => {
        return prev.map((item) => {
          if (item.contact_list_email === contactEmail) {
            return {
              ...item,
              contact_list_image: response.data ? response.data : null,
              contact_list_is_owner_image: false,
            };
          }
          return item;
        });
      });
    }

    closeModal();
  };
  return (
    <div className="action-buttons">
      <div
        className="edit-picture"
        onClick={() =>
          setModal(() => (
            //@ts-ignore
            <UploadContactsPictureModal
              contactImage={details.contact_list_image}
              contactEmail={contactEmail}
              setContactList={setContactList}
            />
          ))
        }
      >
        <div className="profile-img-icon">
          <i className="fa fa-camera camProfileIcon"></i>
        </div>
        {getTextByKey("profileuserdetails-upload-new-profile-btn")}
      </div>
      {isOwnerPicture && (
        <div className="remove-picture" onClick={deleteContactProfilePicture}>
          <Tooltip
            externalControl
            id={"delete-picture"}
            tooltipTextKey={"profileuserdetails-remove-profile-picture-tooltip"}
          >
            <Icon name="trash-solid-b" gray iconClass="profil-remove-icon" />
          </Tooltip>
        </div>
      )}
    </div>
  );
};
